import { postSyncPricingsToCdnByAgentId } from '@nemuru-eng/js-api-client';
import { getPricingsFromCdnByAgentId } from '@nemuru-eng/js-api-client/slim';
import React from 'react';

import { ActionDialog } from '@/components/shared/components/ActionDialog';
import { Text } from '@/components/shared/components/Text';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

export const UploadPricingsToCdnDialog: React.FC<UploadPricingsToCdnDialog> = ({
  agentId,
  opened,
  setOpened,
  handleClose,
}) => {
  const { request, loading } = useRequest();
  const { revalidate } = useCache(getPricingsFromCdnByAgentId, { agentId });
  return (
    <ActionDialog
      Title={<Text tId="UPLOAD_PRICINGS_TO_CDN_DIALOG" />}
      Description={<Text tId={'UPLOAD_PRICINGS_TO_CDN_DIALOG_TEXT'} />}
      MainButton={<Text tId={'UPLOAD_PRICINGS_TO_CDN_DIALOG_BTN'} />}
      onSubmit={async () => {
        await request(postSyncPricingsToCdnByAgentId, { agentId });
        handleClose();
        revalidate();
      }}
      opened={opened}
      setOpened={setOpened}
      handleClose={handleClose}
      loading={loading}
    />
  );
};

interface UploadPricingsToCdnDialog {
  agentId: string;
  opened: boolean;
  setOpened: (opened: boolean) => void;
  handleClose: () => void;
}
